import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_web_cat_fly_anywhere_map_view_www",
    defaultStage: 1,
    stages: {
        main: 1,
        fly_anywhere_list_view: 2,
        fly_anywhere_map_view: 3
    },
    goals: {
        indexBanner: 1,
        mapBannerPage1: 2,
        exploreCard: 3,
        discoverCarousel: 4,
        markerClick: 5
    }
});
export default utils;
